import React, {Fragment} from "react";
import {Button, Col, FormGroup, FormText, Input, Label, Row} from "reactstrap";
import {InputAdapter, TextMask} from "react-text-mask-hoc";
import Select from 'react-select';
import '../../../../scss/vendors/react-select/react-select.scss';
import {DeclinedReasons, getFormFieldValue, setFormFieldValue, traversePropertiesArray,} from '../shared/shared';
import {Physician} from "../components/Physician";

export function HealthInfo(props) {
  const {values, handleCB, readonly, token, formFields, gender = "F"} = props;

  function subSection(namedId, options = {showDeclineReasons: false, showTreatmentLine: true, showDiagnosisLine: true}) {

    return (
      <Fragment>
        <Row>
          <Col xs={"10"}>
            <div>{options.description || "Description Here"}</div>
          </Col>
        </Row>
        {traversePropertiesArray(values, [namedId]).map(function (data, index) {
          return (
            <Row key={index} style={{backgroundColor: "#dfdfdf", marginTop: 2}}>
              <Col xs={2} style={{marginTop: "auto", marginBottom: "auto", textAlign: "right"}}>

                <FormGroup>
                  <Button color="danger"
                          onClick={(evt) => removeArray(namedId, index)}>Remove</Button>
                  {getFormFieldValue(values.hasPhysician) === "1" && (
                    <Fragment>
                      <br/><br/>
                      <Label htmlFor="samePhysician">Health Professional*</Label>
                      <Input type="select" name="samePhysician" id="samePhysician"
                             value={getFormFieldValue(data.samePhysician)}
                             onChange={(evt) => setArrayValues(index, namedId, {
                               ...data,
                               [evt.target.id]: evt.target.value
                             }, [namedId] || {}, readonly, handleCB)}>
                        <option key={0} value={""}>New</option>
                        <option key={1} value={"Y"}>Same as Above</option>
                      </Input>
                    </Fragment>
                  )}
                </FormGroup>
              </Col>
              <Col xs={10}>
                <Fragment>
                  { options.showDeclineReasons && (
                  <FormGroup>
                    <Label htmlFor="why">The Application was:*</Label>
                    <Select
                      id="why"
                      name="why"
                      value={traversePropertiesArray(data, ["why"])}
                      options={DeclinedReasons}
                      onChange={(why) => setArrayValues(index, namedId, {
                        ...data,
                        why: why.map(r => r.value)
                      }, [namedId] || {}, readonly, handleCB)}
                      multi
                    />
                  </FormGroup>
                  )}
                  <Physician values={data || {}}
                             handleCB={(field, value) => setArrayValues(index, namedId, field, data || {}, readonly, handleCB)}
                             readonly={readonly} formFields={formFields} token={token}
                             showAddress={!(getFormFieldValue(values.hasPhysician) === "1" && getFormFieldValue(data.samePhysician) === "Y")}
                             showTreatmentLine={options.showTreatmentLine}
                             showDiagnosisLine={options.showDiagnosisLine}/>
                </Fragment>
              </Col>
            </Row>
          )
        })}
        <Row>
          <Col xs={"1"}/>
          <Col xs={"2"}>
            <Button color="primary"
                    onClick={(evt) => addArray(namedId)}>{traversePropertiesArray(values, [namedId]).length === 0 ? "If Yes, click here" : "Add Row"}</Button>
          </Col>
        </Row>
      </Fragment>
    )
  }

  return (
    <Fragment>
      <Row>
        <Col xs={"12"}>
          <h4>Health Information</h4>
        </Col>
      </Row>

      <Row>
        <Col xs={"2"}>
          <FormGroup>
            <Label htmlFor="heightFt">Height&nbsp;(ft)*</Label>
            <Input type="select" name="heightFt" id="heightFt"
                   value={getFormFieldValue(values.heightFt)}
                   onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}>
              <option key={0} value={""} disabled={true}>Choose</option>
              {Array(5).fill(null).map((val, index) => {
                return (
                  <option key={index + 1} value={index + 3}>{index + 3}</option>
                )
              })}
            </Input>
          </FormGroup>
        </Col>
        <Col xs={"2"}>
          <FormGroup>
            <Label htmlFor="heightIn">Height&nbsp;(in)*</Label>
            <Input type="select" name="heightIn" id="heightIn"
                   value={getFormFieldValue(values.heightIn)}
                   onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}>
              <option key={0} value={""} disabled={true}>Choose</option>
              {Array(12).fill(null).map((val, index) => {
                return (
                  <option key={index + 1} value={index}>{index}</option>
                )
              })}
            </Input>
          </FormGroup>
        </Col>
        <Col xs={"3"}>
          <FormGroup>
            <Label htmlFor="weight">Weight&nbsp;(lbs)*</Label>
            <TextMask
              mask={[/[0-9]/, /[0-9]/, /[0-9]/]}
              Component={InputAdapter}
              className="form-control"
              guide={false}
              showMask={false}
              id="weight"
              value={getFormFieldValue(values.weight)}
              onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}
            />
          </FormGroup>
        </Col>
      </Row>

      <br/>

      <Row>
        {getFormFieldValue(values.hasPhysician) === "1" && (
          <Col xs={"4"}>
            <h5>Physician Info</h5>
          </Col>
        )}

        <Col xs={2}>
          {getFormFieldValue(values.hasPhysician) === "" ?
            <Button color="primary"
                    onClick={(evt) => setFormFieldValue('hasPhysician', "1", values, readonly, handleCB)}>Have
              physician?</Button>
            :
            <Button color="warning"
                    onClick={(evt) => setFormFieldValue('hasPhysician', "", values, readonly, handleCB)}>Remove
              Physician</Button>
          }
        </Col>
      </Row>

      {getFormFieldValue(values.hasPhysician) === "1" && (
        <Fragment>
          <Physician values={values || {}}
                     handleCB={(field, value) => setFormFieldValue(field, value, values, readonly, handleCB)}
                     thisId={"physician"} readonly={readonly} formFields={formFields} token={token}
                     showDiagnosisLine={false} showTreatmentLine={false}/>
        </Fragment>
      )}

      <br/>

      {subSection("medicine", {
        description: "Are you currently taking any other prescribed medications?",
        showTreatmentLine: false,
        showDiagnosisLine: true
      })}

      <br/>

      {subSection("everDeclined", {
        description: "Have you had any application for life, accidental death and dismemberment or disability insurance declined, postponed, withdrawn, rated, modified, or issued other than as applied for?",
        showDeclineReasons: true
      })}

      <br/>

      {subSection("disabilityPay", {
        description: "Are you currently receiving or applying for disability benefits?",
      })}

      <br/>

      <Row>
        <Col xs={"10"}>
          <div>In the past 5 years, have you been convicted of driving while intoxicated or under the influence of
            alcohol and/or any drug?
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={"1"}/>
        {traversePropertiesArray(values, ['dwiConviction']).length > 0 && (
          <Col xs={"3"}>
            <FormGroup>
              <Label htmlFor="convictionDate">Date of Conviction*</Label>
              <TextMask
                mask={[/[0-1]/, /\d/, '/', /[0-3]/, /\d/, '/', /[1-2]/, /[09]/, /\d/, /\d/]}
                Component={InputAdapter}
                className="form-control"
                id="convictionDate"
                value={getFormFieldValue(traversePropertiesArray(values, ['dwiConviction'])[0].convictionDate)}
                onChange={(evt) => setArrayValues(0, "dwiConviction", {convictionDate: evt.target.value}, values, readonly, handleCB)}
              />
              <FormText color="muted">
                MM/DD/YYYY (ex. 08/26/1984)
              </FormText>
            </FormGroup>
          </Col>
        )}
        <Col xs={"2"}>
          {traversePropertiesArray(values, ['dwiConviction']).length === 0 ?
            <Button color="primary"
                    onClick={(evt) => addArray('dwiConviction')}>If Yes, click here</Button>
            :

            <Button color="danger"
                    onClick={(evt) => removeArray('dwiConviction', 0)}>Remove</Button>
          }
        </Col>

      </Row>

      <br/>

      {subSection("hiv", {
        description: "Have you ever been diagnosed or treated by a physician or other health care provider for Acquired Immunodeficiency Syndrome (AIDS), AIDS Related Complex (ARC) or the Human Immunodeficiency Virus (HIV) infection?",
      })}

      <br/>

      {subSection("anyDisease", {
        description: "Have you ever been diagnosed, treated or given medical advice by a physician or other health care\n" +
          "            provider for: cardiac or cardiovascular disorder; stroke or circulatory disorder; high blood pressure;\n" +
          "            cancer; blood disorder; diabetes; lung disease; liver or intestinal disorder; mental illness, anxiety,\n" +
          "            depression, attempted suicide or nervous disorder?",
      })}

      <br/>

      {subSection("hospitalized", {
        description: "In the past 5 years, have you been Hospitalized as defined below" + (getFormFieldValue(gender) !== "F" ? "" : " (not including well-baby delivery)") + ": Hospitalized means admission for inpatient care in a hospital; receipt of care in a hospice facility, intermediate care facility, or long term care facility; or receipt of the following treatment wherever performed:chemotherapy, radiation therapy, or dialysis.",
      })}

      <br/>

      {subSection("advice", {
        description: "In the past 5 years, have you been diagnosed, treated or given medical advice by a physician or other health care provider for any other medical condition or had a surgical procedure (other than oral surgery)?",
      })}

    </Fragment>
  );

  function setArrayValues(index, field, value, medicineObj, readonly1, handleCB1) {
    const newValues = traversePropertiesArray(values, [field]);
    newValues[index] = value;
    setFormFieldValue(field, newValues, values, readonly, handleCB);
  }

  function addArray(type) {
    const newValues = traversePropertiesArray(values, [type]);
    newValues.push({});
    values[type] = newValues;
    handleCB(values);
  }

  function removeArray(type, index) {
    const newValues = traversePropertiesArray(values, [type]);
    newValues.splice(index, 1);
    values[type] = newValues;
    handleCB(values);
  }
}


// WEBPACK FOOTER //
// ./src/containers/Applications/sections/HealthInfo.js